import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Chip = styled.button<{ $active: boolean; $size: "medium" | "small" }>`
    height: ${({ $size }) => ($size === "small" ? "36px" : "44px")};
    padding: ${({ $size }) => ($size === "small" ? "0 14px" : "0 16px")};
    border-radius: ${radii.chip};
    font-size: ${({ $size }) => ($size === "small" ? "0.8125rem" : "0.875rem")};
    font-weight: 600;
    cursor: pointer;
    background: ${({ $active }) =>
        $active ? "rgba(25,118,210,0.08)" : colors.surface};
    color: ${({ $active }) => ($active ? colors.primary : colors.fieldLabel)};
    border: 1px solid ${({ $active }) => ($active ? colors.primary : colors.fieldBorder)};
`;
